import { render, staticRenderFns } from "./CreatePredictClientAccount.vue?vue&type=template&id=22ad07e3&"
import script from "./CreatePredictClientAccount.vue?vue&type=script&lang=js&"
export * from "./CreatePredictClientAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports